'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

export default function GTMPageView() {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      window.dataLayer?.push({
        event: 'page_view',
        page: pathname,
      });
    }
  }, [pathname]);

  return null;
}